import { PropertyProxy, ConfigProxy } from '../_helpers/util'
import SubmittedImg from '../assets/img/submitted.png'
const DEFAULT_CONFIG = {
  title: 'Finalizing Rate',
  body: 'We are looking at your submission and are working to get you the best possible rate. You should receive a final rate within 24 hours.',
  submittedImg: SubmittedImg,
  //putting submitted href here because it is a valid config option, but should be undefined for most tenants
  submittedHref: undefined,
}
export const SubmitConfig = ConfigProxy(
  {
    newcenturyfinancial: PropertyProxy(
      {
        title: 'Application Received',
        submittedImg:
          'https://finvoice-tenants.s3.amazonaws.com/finvoice-app/staging/newcenturyfinancial/email_header_logo.png',
      },
      DEFAULT_CONFIG
    ),
    portercapital: PropertyProxy(
      {
        title: 'Finalizing Rate . . .',
        body: 'Please be available in the next hour so Porter Capital can ensure your application is complete and that we are able to get you funded by the date you requested.',
        finalizingRateImg:
          'https://finvoice-tenants.s3.amazonaws.com/finvoice-app/staging/portercapital/submitted_left.png',
        submittedImg:
          'https://finvoice-tenants.s3.amazonaws.com/finvoice-app/staging/portercapital/submitted_right.png',
        submittedHref: 'https://www.trustpilot.com/review/www.portercap.net',
      },
      DEFAULT_CONFIG
    ),
    marcocapital: PropertyProxy(
      {
        title: 'Finalizing Rate . . .',
      },
      DEFAULT_CONFIG
    ),
    marcofi: PropertyProxy(
      {
        title: 'Finalizing Rate . . .',
      },
      DEFAULT_CONFIG
    ),
    scfactoringsolution: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We are looking at your submission and are working to get you the best possible rate. You should receive a final rate within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    sallyportcf: PropertyProxy(
      {
        title: 'Application Received',
        body: 'Thank you for your submission. We will review and contact you within 24 hours.',
        submittedImg: 'https://finvoice-tenants.s3.amazonaws.com/finvoice-app/staging/sallyportcf/submitted.png',
      },
      DEFAULT_CONFIG
    ),

    sevenoaks: PropertyProxy(
      {
        title: 'Application Received',
        body: 'You should receive a final approval within 24 hours.',
        submittedImg: `https://finvoice-tenants.s3.amazonaws.com/finvoice-app/prod/sevenoaks/email_header_logo.png`,
      },
      DEFAULT_CONFIG
    ),
    acsfactors: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We are looking at your submission and are working to get you the best possible rate. You should receive a final rate within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    twelvefive: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We are now reviewing your application. We will get back to you in the next business day.',
      },
      DEFAULT_CONFIG
    ),
    capitalnow: PropertyProxy(
      {
        title: 'Application Received',
        body: 'Thank you for your submission. We will review and contact you within 1 business day.',
        submittedImg: 'https://finvoice-tenants.s3.amazonaws.com/finvoice-app/staging/capitalnow/submitted.png',
      },
      DEFAULT_CONFIG
    ),
    ccbg: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We are looking at your submission and are working to get you the best possible rate. You should receive a final rate within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    hedayacapital: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We are looking at your submission and are working to get you the best possible rate. You should receive a final rate within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    republicbc: PropertyProxy(
      {
        title: 'Application Received',
        body: 'Thank you for your submission. We will review and contact you within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    newbridgeglobal: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We have received your submission and a Newbridge Global representative will contact you within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    axosbank: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We are looking at your submission and are working to get you the best possible rate. You should receive a final rate within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    capitalplus: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We appreciate your interest in working with CapitalPlus. Please be aware your application is not complete, and we will need additional information to complete the process. \n\nYou should expect to hear from one of our team members within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    capitalplusfinancial: PropertyProxy(
      {
        title: 'Application Received',
        body: 'We appreciate your interest in working with CapitalPlus. Please be aware your application is not complete, and we will need additional information to complete the process. \n\nYou should expect to hear from one of our team members within 24 hours.',
      },
      DEFAULT_CONFIG
    ),
    velocityfi: PropertyProxy(
      {
        title: 'Application Submitted',
        body: 'We are looking at your submission and are working to get you the best possible rate. You should receive an update from our team within 1 business day.',
      },
      DEFAULT_CONFIG
    ),
  },
  DEFAULT_CONFIG
)
